<p-breadcrumb class="max-w-full fixed z-index-max" [model]="breadcrumbService.breadcrumbs()">
  @for (item of breadcrumbService.breadcrumbs(); track item; let last = $last) {
    <span [class]="{ 'link': !last }" (click)="!last && goTo(item.routerLink)">
      @if (item.icon) {
        <i [class]="item.icon"></i>
      }
      {{ item.id! | translate }}
    </span>
  }
  <ng-template #separator>&rsaquo;</ng-template>
</p-breadcrumb>
<div class="spacer"></div>
